import posthog from "posthog-js";
import { CONSENT_EVENT, CONSENT_KEY, readConsent } from "./library/cookie-consent";

function syncAnalyticsConsent() {
  if (!readConsent()?.analytics) {
    if (posthog.__loaded) posthog.opt_out_capturing();
    return;
  }
  if (posthog.__loaded) {
    posthog.opt_in_capturing();
    return;
  }
  // No SDK initialization or remote configuration requests before consent.
  if (!process.env.NEXT_PUBLIC_POSTHOG_KEY) return;
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    defaults: "2025-11-30",
    disable_session_recording: true,
    before_send: (event) => readConsent()?.analytics ? event : null,
    loaded: (client) => client.opt_in_capturing(),
  });
}

syncAnalyticsConsent();
window.addEventListener(CONSENT_EVENT, syncAnalyticsConsent);
window.addEventListener("storage", (event) => {
  if (event.key === CONSENT_KEY || event.key === null) {
    syncAnalyticsConsent();
    // Unload third-party scripts when preferences change in another tab.
    window.location.reload();
  }
});
